import type { DeactivateProfilesResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import { profileQueryHttp } from '../../_shared/infrastructure/profile-query.http';
import type { ProfilesGateway } from './profiles.gateway';

/**
 * Real implementation over the shared api client; the single place that knows the
 * admin Profiles list's write endpoint (bulk deactivate), kept 1:1 with the
 * original page. The paginated profile read is spread in from the shared
 * `profileQueryHttp`.
 */
export const httpProfilesGateway: ProfilesGateway = {
  deactivateProfiles: (ids, scope) =>
    api.post<DeactivateProfilesResponse>('/profiles/deactivate', {
      profile_ids: ids,
      scope,
    }),

  ...profileQueryHttp,
};
